import React, { Fragment, useRef, useState } from 'react';
import { StyleClass } from 'primereact/styleclass';
import { Button } from 'primereact/button';

function MMInfo({ mm }) {
    const openBtnRef = useRef(null);
    const closeBtnRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);

    if (!mm) return null;
    return (
        <Fragment>
            <div className="field md:col-6 col-12">
                <ul className="list-none p-0 m-0 border-top-1 border-300">
                    {/* <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between  ">
                        <div className=" md:w-4 font-medium">Šifra MM:</div>
                        <div className="text-900 md:w-8">{mm.sifra_mm}</div>
                    </li> */}
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between surface-ground ">
                        <div className=" md:w-4 font-medium">Ulica:</div>
                        <div className="text-900 md:w-8">
                            {mm.ulica} {mm.kucni_broj}
                        </div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between  ">
                        <div className=" md:w-4 font-medium">Mesto:</div>
                        <div className="text-900 md:w-8">
                            {mm.mesto} {mm.postanski_broj}
                        </div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between surface-ground">
                        <div className="md:w-4 font-medium">Ime vlasnika:</div>
                        <div className="text-900 md:w-8">{mm.p?.ime_vlasnika}</div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between surface-ground">
                        <div className="md:w-4 font-medium">Telefon vlasnika:</div>
                        <div className="text-900 md:w-8">{mm.p?.telefon_vlasnika}</div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between">
                        <div className="md:w-4 font-medium">Barkod merača:</div>
                        <div className="text-900 md:w-8">{mm.m?.barkod_meraca}</div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-center  ">
                        {!isOpen && <Button icon="pi pi-plus" outlined text ref={openBtnRef} label="Više" className="mr-2 w-3" onClick={() => setIsOpen(true)} />}
                        {isOpen && <Button icon="pi pi-minus" outlined text ref={closeBtnRef} label="Manje" className="mr-2 w-3" onClick={() => setIsOpen(false)} />}
                    </li>
                </ul>
            </div>

            <div className="field md:col-6 col-12 " hidden={!isOpen}>
                <ul className="list-none p-0 m-0 border-top-1 border-300">
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between ">
                        <div className=" md:w-4 font-medium">Datum zamene merača:</div>
                        <div className="text-900 md:w-8">{mm.datum_zamene_meraca}</div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between surface-ground ">
                        <div className=" md:w-4 font-medium">Datum pregleda KGP:</div>
                        <div className="text-900 md:w-8">{mm.datum_pregleda_kgp}</div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between ">
                        <div className=" md:w-4 font-medium">Datum pregleda UGI:</div>
                        <div className="text-900 md:w-8">{mm.datum_pregleda_ugi}</div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between surface-ground ">
                        <div className="md:w-4 font-medium">Šifra potrošača:</div>
                        <div className="text-900 md:w-8">{mm.p?.sifra_potrosaca}</div>
                    </li>

                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between">
                        <div className="md:w-4 font-medium">Email vlasnika:</div>
                        <div className="text-900 md:w-8">{mm.p?.email_vlasnika}</div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between surface-ground">
                        <div className="md:w-4 font-medium">Ime korisnika:</div>
                        <div className="text-900 md:w-8">{mm.p?.ime_korisnika}</div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between">
                        <div className="md:w-4 font-medium">Telefon korisnika:</div>
                        <div className="text-900 md:w-8">{mm.p?.telefon_korisnika}</div>
                    </li>
                    <li className="flex align-items-center py-2 px-2 flex-wrap justify-content-between surface-ground">
                        <div className="md:w-4 font-medium">Email korisnika:</div>
                        <div className="text-900 md:w-8">{mm.p?.email_korisnika}</div>
                    </li>
                </ul>
            </div>
        </Fragment>
    );
}

export default MMInfo;
